var processInclude = require('./util');
require('simplelightbox');

$(document).ready(function () {
    processInclude(require('./components/jqzoom'));
    processInclude(require('./product/detail'));
});
